/**
 * Onboarding + Help UI state (P2.1-S6).
 */
import { create } from "zustand";

interface OnboardingUIState {
  welcomeOpen: boolean;
  helpOpen: boolean;
  openWelcome: () => void;
  closeWelcome: () => void;
  openHelp: () => void;
  closeHelp: () => void;
  toggleHelp: () => void;
}

export const useOnboardingStore = create<OnboardingUIState>((set) => ({
  welcomeOpen: false,
  helpOpen: false,
  openWelcome: () => set({ welcomeOpen: true }),
  closeWelcome: () => set({ welcomeOpen: false }),
  openHelp: () => set({ helpOpen: true }),
  closeHelp: () => set({ helpOpen: false }),
  toggleHelp: () => set((s) => ({ helpOpen: !s.helpOpen })),
}));
